<!--loader-->
<div class="f-1-0 flex-column centralize" *ngIf="!isThisFeatureSupported">
	<loader height="100" width="100" style="opacity: 0.8;" *ngIf="_.isUndefined(isThisFeatureSupported)"></loader>
	<threat-simulation-not-supported style="display: contents;" *ngIf="isThisFeatureSupported === false"></threat-simulation-not-supported>
</div>

<div class="ts-config-page flex-column gap-4 animated fadeIn" *ngIf="isThisFeatureSupported">

	<!-- Welcome Banner -->
	<div class="welcome-banner">
		<div class="welcome-icon">
			<i class="far fa-rocket"></i>
		</div>
		<div class="welcome-text">
			<h1>Welcome to Threat Simulation</h1>
			<p>Complete the setup below to start launching security awareness campaigns</p>
		</div>
	</div>

	<!-- Setup Section -->
	<div class="config-section">
		<div class="section-title">
			<i class="far fa-cogs"></i>
			<span>Setup</span>
			<span class="required-label">Required</span>
		</div>

		<div class="config-cards">
			<!-- Mail Server Configuration -->
			<div class="config-card">
				<div class="card-header">
					<div class="card-icon">
						<i class="far fa-envelope-open-text"></i>
					</div>
					<div class="card-title">
						<h3>Configure Your Mail Environment</h3>
						<p>Allowlist Trustifi so simulation emails land in mailboxes, not spam</p>
					</div>
				</div>
				<div class="card-body">
					<span class="card-label">Choose your platform:</span>
					<div class="platform-buttons">
						<a class="platform-btn"
						   href="https://docs.trustifi.com/docs/enabling-the-threat-simulation-service#microsoft-defender-office-365-configuration"
						   target="_blank" rel="noopener noreferrer nofollow">
							<i class="fab fa-microsoft" style="color: #00a1f1;"></i>
							<span>Microsoft 365</span>
							<i class="far fa-external-link-alt"></i>
						</a>
						<a class="platform-btn"
						   href="https://docs.trustifi.com/docs/enabling-the-threat-simulation-service#google-workspace-configuration"
						   target="_blank" rel="noopener noreferrer nofollow">
							<img src="images/integrationsLogos/gsuite-logo.png" alt="Google">
							<span>Google Workspace</span>
							<i class="far fa-external-link-alt"></i>
						</a>
					</div>
				</div>
			</div>

			<!-- Template Parameters -->
			<div class="config-card" [ngClass]="{'completed': threatSimulationConfig?.template_fields?.company}">
				<div class="card-header">
					<div class="card-icon">
						<i class="far fa-building"></i>
					</div>
					<div class="card-title">
						<h3>Set Up Organization Details</h3>
						<p>Add your company info to personalize simulation emails</p>
					</div>
					<div class="card-status" *ngIf="threatSimulationConfig?.template_fields?.company">
						<i class="far fa-check-circle"></i>
					</div>
				</div>
				<div class="card-body">
					<a class="action-link"
					   [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.configuration, dic.CONSTANTS.threatSimulationConfigPageTabs.customization]">
						{{threatSimulationConfig?.template_fields?.company ? 'Edit Parameters' : 'Configure Parameters'}}
						<i class="far fa-arrow-right"></i>
					</a>
				</div>
			</div>
		</div>
	</div>

	<!-- Next Steps Section -->
	<div class="config-section">
		<div class="section-title">
			<i class="far fa-flag-checkered"></i>
			<span>Next Steps</span>
		</div>

		<div class="next-cards">
			<!-- Campaigns -->
			<a class="next-card"
			   [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.campaigns]">
				<div class="next-icon">
					<i class="far fa-paper-plane"></i>
				</div>
				<div class="next-content">
					<h3>Launch Campaigns</h3>
					<p>Create phishing simulations and training campaigns to test your employees</p>
				</div>
				<i class="far fa-chevron-right"></i>
			</a>

			<!-- Training Materials -->
			<a class="next-card"
			   [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.trainingMaterials]">
				<div class="next-icon">
					<i class="far fa-graduation-cap"></i>
				</div>
				<div class="next-content">
					<h3>Training Materials</h3>
					<p>Browse our library of training videos, quizzes, and educational content</p>
				</div>
				<i class="far fa-chevron-right"></i>
			</a>

			<!-- AI Creation -->
			<a class="next-card ai-highlight"
			   [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.trainingMaterials]">
				<div class="ai-badge">AI</div>
				<div class="next-icon">
					<i class="far fa-brain"></i>
				</div>
				<div class="next-content">
					<h3>Create with AI</h3>
					<p>Generate custom training videos and phishing templates using AI</p>
				</div>
				<i class="far fa-chevron-right"></i>
			</a>

			<!-- Templates -->
			<a class="next-card"
			   [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.templates]">
				<div class="next-icon">
					<i class="far fa-clone"></i>
				</div>
				<div class="next-content">
					<h3>Browse Templates</h3>
					<p>Explore phishing templates covering all common attack vectors</p>
				</div>
				<i class="far fa-chevron-right"></i>
			</a>
		</div>
	</div>

	<!-- Support Banner -->
	<div class="support-banner">
		<i class="far fa-headset"></i>
		<span>Need help? Our support team responds fast!</span>
		<a [routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets]"
		   [state]="{ data: 'open' }">
			Contact Support
		</a>
	</div>
</div>
